import { deepClone } from '@zz-yp/hunter-js-utils'
import Vue from 'vue'
const state = {
  params: {},
  // 成色选项列表
  qualityList: [],
  // 外观成色选项列表
  appearanceList: [],
  // 功能成色选项列表
  functionList: [],
  // 成色选项列表
  capacityList: [],
  originalCapacityList: [],
  // 是否显示价格区间
  isShowPrice: false,
  // 价格区间
  priceRange: {
    maxPrice: '',
    minPrice: ''
  },
  skuListHas: true,
  sortList: [],
  brandList: [],
  modelList: [],
  modelTopList: [],
  conditionList: [],
  sourceList: [],
  dealTimeList: [],
  groupList: [],
  gradeList: [],
  filterList: [],
  qualityGradeList: [],
  mySearchList: [],
  sortIdList: [],
  myFilterVersionList: [],
  myQuickOptsId: '',
  // 是否点击我的筛选选项
  isClickMyQuickOpts: false,
  // 是否通过点击管理我的筛选进入列表页
  isRefreshMySearchList: false,
  customObj: {},
  freezeFilterList: [],
  freezeCapacityList: [],
  freezeCapacityCount: 0,
  freezeAttributeCount: 0,
  //机况聚合list（一口价列表筛选新增）
  conditionPolymerizationList: []
}

const mutations = {
  // 复合机况列表
  SET_CONDITION_POLYMERIZATION_LIST: (state, payload) => {
    state.conditionPolymerizationList = payload
    state = deepClone(state)
  },
  SET_ORIGINAL_CAPACITY_LIST: (state, payload) => {
    state.originalCapacityList = payload
  },
  // 设置选中参数
  SET_PARAMS: (state, payload) => {
    state.params = Object.assign({}, state.params, payload)
    state = deepClone(state)
  },
  // 重置params
  SET_RESET_PARAMS: (state) => {
    const keys = Object.keys(state.params)
    keys.forEach((key) => {
      Vue.set(state.params, key, '')
    })

    console.log(state.params)
  },
  // 刷新 params 参数
  REFRESH_PARAMS: (state) => {
    const arr = ['sortId', 'brandId', 'modelIds', 'b2bGradeIds', 'levelIds', 'ramAndCapacityIds']
    state.filterList.forEach((x) => {
      arr.push(x.queryKey)
    })
    state.qualityGradeList.forEach((x) => {
      arr.push(x.queryKey)
    })
    arr.forEach((x) => {
      delete state.params[x]
    })
    state.myQuickOptsId = ''
    state = deepClone(state)
  },

  // 设置排序列表
  SET_SORT_LIST: (state, payload) => {
    state.sortList = payload
    state = deepClone(state)
  },

  // 设置品牌列表
  SET_BRAND_LIST: (state, payload) => {
    state.brandList = payload
    state = deepClone(state)
  },

  // 设置机况列表
  SET_CONDITION_LIST: (state, payload) => {
    state.conditionList = payload
    state = deepClone(state)
  },

  // 设置成交来源列表
  SET_SOURCE_LIST: (state, payload) => {
    state.sourceList = payload
    state = deepClone(state)
  },

  // 设置成交时间列表
  SET_DEAL_TIME_LIST: (state, payload) => {
    state.dealTimeList = payload
    state = deepClone(state)
  },

  // 设置型号列表
  SET_MODEL_LIST: (state, payload) => {
    state.modelList = payload
    state = deepClone(state)
  },
  // 设置型号顶部列表
  SET_MODEL_TOP_LIST: (state, payload) => {
    state.modelTopList = payload
    state = deepClone(state)
  },

  // 设置成色列表
  SET_QUALITY_LIST: (state, payload) => {
    state.qualityList = payload
    state = deepClone(state)
  },
  // 设置外观成色列表
  SET_APPEARANCE_LIST: (state, payload) => {
    state.appearanceList = payload
    state = deepClone(state)
  },
  // 设置功能成色列表
  SET_FUNCTION_LIST: (state, payload) => {
    state.functionList = payload
    state = deepClone(state)
  },
  // 设置容量列表
  SET_CAPACITY_LIST: (state, payload) => {
    state.capacityList = payload
    state = deepClone(state)
  },

  // 设置等级组列表
  SET_GROUP_LIST: (state, payload) => {
    state.groupList = payload
    state = deepClone(state)
  },

  // 设置等级列表
  SET_GRADE_LIST: (state, payload) => {
    state.gradeList = payload
    state = deepClone(state)
  },
  // 设置排序列表
  SET_SORT_ID_LIST: (state, payload) => {
    state.sortIdList = payload
    state = deepClone(state)
  },

  // 设置属性列表
  SET_FILTER_LIST: (state, payload) => {
    state.filterList = payload
    state = deepClone(state)
  },
  // 设置成色等级列表
  SET_QUALITY_GRADE_LIST: (state, payload) => {
    state.qualityGradeList = payload
    state = deepClone(state)
  },

  // 设置是否显示价格区间
  SET_IS_SHOW_PRICE: (state, payload) => {
    state.isShowPrice = payload
    state = deepClone(state)
  },

  // 设置价格区间
  SET_PRICE_RANGE: (state, payload) => {
    state.priceRange = payload
    state = deepClone(state)
  },

  // 设置我的筛选列表
  SET_MY_SEARCH_LIST: (state, payload) => {
    state.mySearchList = payload
    state = deepClone(state)
  },

  // 设置我的筛选 ID
  SET_MY_QUICK_OPTS_ID: (state, payload) => {
    state.myQuickOptsId = payload
    state = deepClone(state)
  },

  SET_VERSION_LIST: (state, payload) => {
    state.myFilterVersionList = payload
    state = deepClone(state)
  },

  // 是否点击我的筛选
  IS_CLICK_MY_QUICK_OPTS: (state, payload) => {
    state.isClickMyQuickOpts = payload
    state = deepClone(state)
  },

  // 点击管理我的筛选
  IS_REFRESH_MY_SEARCH_LIST: (state, payload) => {
    state.isRefreshMySearchList = payload
    state = deepClone(state)
  },
  // 设置自定义列表
  SET_CUSTOM_LIST: (state, payload) => {
    const type = payload['type']
    const list = payload['list']
    state.customObj[type] = list
    state = deepClone(state)
  },
  SET_CUSTOM_OBJ: (state, payload) => {
    state.customObj = payload
    state = deepClone(state)
  },
  SET_SKU_HAS: (state, payload) => {
    state.skuListHas = payload
    state = deepClone(state)
  },
  SET_FREEZE_FILTERLIST: (state, payload) => {
    state.freezeFilterList = payload
    state = deepClone(state)
  },
  SET_FREEZE_CAPACITYLIST: (state, payload) => {
    state.freezeCapacityList = payload
    state = deepClone(state)
  },
  SET_FREEZE_CAPACITYCOUNT: (state, payload) => {
    state.freezeCapacityCount = payload
    state = deepClone(state)
  },
  SET_FREEZE_ATTRIBUTECOUNT: (state, payload) => {
    state.freezeAttributeCount = payload
    state = deepClone(state)
  },
  RESET_CONDITION_FILTER: (state) => {
    // 重置机况聚合列表的选中状态
    const originalList = state.conditionPolymerizationList || []
    const clearedList = originalList.map((item) => {
      const newItem = { ...item }
      if (Array.isArray(item.data)) {
        newItem.data = item.data.map((y) => ({ ...y, checked: false }))
      }
      if (item && item.type === '4' && item.data && typeof item.data === 'object') {
        const groupList = Array.isArray(item.data.groupList) ? item.data.groupList : []
        const gradeList = Array.isArray(item.data.gradeList) ? item.data.gradeList : []
        newItem.data = {
          ...item.data,
          groupList: groupList.map((y) => ({ ...y, checked: false })),
          gradeList: gradeList.map((y) => ({ ...y, checked: false }))
        }
      }
      return newItem
    })
    state.conditionPolymerizationList = clearedList

    // 重置价格区间
    state.priceRange = { minPrice: '', maxPrice: '' }

    // 清空机况相关的请求参数
    const clearParams = {}
    clearedList.forEach((item) => {
      if (item && item.filterType != '1' && item.queryKey) {
        clearParams[item.queryKey] = ''
      }
    })
    clearParams.labelIdOptions = ''
    clearParams.minPrice = ''
    clearParams.maxPrice = ''

    // 更新 params
    Object.keys(clearParams).forEach((key) => {
      Vue.set(state.params, key, clearParams[key])
    })

    state = deepClone(state)
  }
}

const getters = {
  getCapacityList: (state) => state.capacityList,
  getOriginalCapacityList: (state) => state.originalCapacityList,
  getFilterOptionList: (state) => state.filterList
}
export default {
  namespaced: true,
  state,
  mutations,
  getters
}
